import Immutable from 'immutable';
import { combineReducers } from 'redux';
import { AUTHENTICATION, NETWORK, SUBSCRIPTION } from './actions';
import {
  GET_CUSTOMER,
  GET_CUSTOMER_TASKS,
  UPDATE_CUSTOMER,
} from './components/customer/actions';
import { GET_INVOICES } from './components/invoices/actions';
import {
  GET_BAR_SERVICES,
  GET_DATA_PACKAGES,
  GET_NETWORK_SERVICES,
  GET_SIM_CARD_INFO,
  GET_SUBSCRIPTION_INFO,
  GET_SUBSCRIPTION_TASKS,
  GET_SUBSCRIPTIONS,
} from './components/subscriptions/actions';
import { isAuthenticated } from './utils/session';

function appState(
  state = Immutable.Map({
    maintenance: false,
    networkFailed: false,
    networkProgress: false,
    subscriptionProgress: false,
    authenticated: isAuthenticated(),
    showNavigation: true,
  }),
  action = null,
) {
  switch (action.type) {
    case NETWORK:
    case SUBSCRIPTION:
    case AUTHENTICATION:
      return state.merge(action.state);

    default:
      return state;
  }
}

function customer(state = Immutable.Map(), action = null) {
  switch (action.type) {
    case AUTHENTICATION:
    case GET_CUSTOMER:
    case UPDATE_CUSTOMER:
      return state.merge(action.customer);

    case GET_CUSTOMER_TASKS: {
      const statejs = state.toJS();
      action.tasks.forEach((task) => {
        if (statejs.deliveryAddress.id === task.addressId) {
          statejs.deliveryAddress.hasActiveAddressChangeTask = true;
          statejs.deliveryAddress.task = task;
        }

        statejs.invoiceAddresses.forEach((address) => {
          if (address.id === task.addressId) {
            address.hasActiveAddressChangeTask = true;
            address.task = task;
          }
        });
      });
      statejs.tasks = action.tasks;
      return state.merge(statejs);
    }

    default:
      return state;
  }
}

function invoices(state = Immutable.List(), action = null) {
  switch (action.type) {
    case GET_INVOICES:
      return state.merge(action.invoices);

    default:
      return state;
  }
}

function subscriptions(state = Immutable.List(), action = null) {
  switch (action.type) {
    case GET_SUBSCRIPTIONS:
      return state.merge(action.subscriptions);

    default:
      return state;
  }
}

function subscription(state = Immutable.Map(), action = null) {
  switch (action.type) {
    case GET_SIM_CARD_INFO:
    case GET_DATA_PACKAGES:
    case GET_NETWORK_SERVICES:
    case GET_SUBSCRIPTION_INFO:
    case GET_BAR_SERVICES:
      return state.merge(action.subscription);
    case GET_SUBSCRIPTION_TASKS:
      return state.merge({ tasks: action.tasks });
    default:
      return state;
  }
}

const rootReducer = combineReducers({
  appState,
  customer,
  invoices,
  subscriptions,
  subscription,
});

export default rootReducer;
